import { useContext } from 'react';
import { AppContext } from '../context/AppContext';

// Hook personnalisé pour faciliter l'accès au contexte
export const useAppContext = () => {
  const context = useContext(AppContext);
  
  if (context === undefined) {
    throw new Error("useAppContext doit être utilisé à l'intérieur d'un AppProvider");
  }
  
  return context;
};
